/** Powered by @ttoss/config. https://ttoss.dev/docs/modules/packages/config/ */

// tsup.inject.js
import * as React from "react";

// src/components/Accordion/Accordion.tsx
import * as React2 from "react";
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  Accordion as ReactAccessibleAccordion
} from "react-accessible-accordion";
import { Box, useTheme } from "@ttoss/ui";
import { css as createClassName } from "@emotion/css";
import { css as transformStyleObject } from "@theme-ui/css";
import { jsx } from "react/jsx-runtime";
var Accordion = ({
  children,
  allowMultipleExpanded,
  allowZeroExpanded,
  preExpanded,
  onChange,
  ...boxProps
}) => {
  const { theme } = useTheme();
  const className = React2.useMemo(() => {
    const styles = transformStyleObject({
      ".accordion__item": {
        marginBottom: 3
      },
      ".accordion__heading": {
        padding: 2,
        border: "1px solid",
        borderColor: "black"
      },
      ".accordion__button": {},
      ".accordion__panel": {
        padding: 2
      }
    })(theme);
    return createClassName(styles);
  }, [theme]);
  return /* @__PURE__ */ jsx(Box, {
    variant: "accordion",
    className,
    ...boxProps,
    children: /* @__PURE__ */ jsx(ReactAccessibleAccordion, {
      ...{
        allowMultipleExpanded,
        allowZeroExpanded,
        preExpanded,
        onChange
      },
      children
    })
  });
};
Accordion.Item = AccordionItem;
Accordion.ItemButton = AccordionItemButton;
Accordion.ItemHeading = AccordionItemHeading;
Accordion.ItemPanel = AccordionItemPanel;

// src/components/InstallPwa/InstallPwa.tsx
import * as React3 from "react";

// src/components/InstallPwa/InstallPwaUi.tsx
import { Button, Flex, Text } from "@ttoss/ui";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var InstallPwaUi = ({ onInstall }) => {
  return /* @__PURE__ */ jsx2(Flex, {
    sx: {
      position: "absolute",
      bottom: 4,
      width: "100%",
      justifyContent: "center"
    },
    children: /* @__PURE__ */ jsxs(Flex, {
      sx: {
        backgroundColor: "background",
        justifyContent: "center",
        alignItems: "center",
        gap: 3,
        width: "auto",
        border: "1px solid",
        borderColor: "muted",
        borderRadius: 1,
        padding: 4
      },
      children: [
        /* @__PURE__ */ jsx2(Text, {
          children: "Deseja instalar o nosso aplicativo?"
        }),
        /* @__PURE__ */ jsx2(Button, {
          onClick: onInstall,
          children: "Instalar"
        })
      ]
    })
  });
};

// src/components/InstallPwa/InstallPwa.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var InstallPwa = () => {
  const [supportsPwa, setSupportsPwa] = React3.useState(false);
  const [promptInstall, setPromptInstall] = React3.useState(null);
  React3.useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPwa(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("transitionend", handler);
  }, []);
  const onInstall = (e) => {
    e.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPwa) {
    return null;
  }
  return /* @__PURE__ */ jsx3(InstallPwaUi, {
    onInstall
  });
};

// src/components/Modal/Modal.tsx
import { useResponsiveValue, useTheme as useTheme2 } from "@ttoss/ui";
import ReactModal from "react-modal";
import { jsx as jsx4 } from "react/jsx-runtime";
ReactModal.defaultStyles = {
  overlay: {},
  content: {}
};
var Modal = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { theme } = useTheme2();
  const padding = useResponsiveValue([
    (_a = theme.space) == null ? void 0 : _a[2],
    (_b = theme.space) == null ? void 0 : _b[3],
    (_c = theme.space) == null ? void 0 : _c[4]
  ]) || 0;
  const style = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding,
      ...(_d = props.style) == null ? void 0 : _d.overlay
    },
    content: {
      backgroundColor: ((_f = (_e = theme.rawColors) == null ? void 0 : _e.background) == null ? void 0 : _f.toString()) || "#fff",
      padding,
      WebkitOverflowScrolling: "touch",
      overflow: "auto",
      position: "relative",
      top: "0px",
      left: "0px",
      right: "0px",
      bottom: "0px",
      border: "2px solid",
      borderColor: ((_h = (_g = theme.rawColors) == null ? void 0 : _g.muted) == null ? void 0 : _h.toString()) || "#fff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      ...(_i = props.style) == null ? void 0 : _i.content
    }
  };
  return /* @__PURE__ */ jsx4(ReactModal, {
    ...props,
    style
  });
};
Modal.setAppElement = ReactModal.setAppElement;

// src/components/Toast/Toast.tsx
import * as React4 from "react";
import { Box as Box2 } from "@ttoss/ui";
import {
  ToastContainer as ReactToastifyToastContainer,
  toast
} from "react-toastify";
import { injectStyle } from "react-toastify/dist/inject-style";
import { jsx as jsx5 } from "react/jsx-runtime";
var ToastContainer = (props) => {
  React4.useEffect(() => {
    injectStyle();
  }, []);
  return /* @__PURE__ */ jsx5(Box2, {
    sx: ({ colors, fonts }) => ({
      "--toastify-color-light": "#fff",
      "--toastify-color-dark": "#121212",
      "--toastify-color-info": (colors == null ? void 0 : colors.info) || "#3498db",
      "--toastify-color-success": (colors == null ? void 0 : colors.success) || "#07bc0c",
      "--toastify-color-warning": "#f1c40f",
      "--toastify-color-error": "#e74c3c",
      "--toastify-color-progress-light": `linear-gradient(to right, ${colors == null ? void 0 : colors.primary}, ${colors == null ? void 0 : colors.secondary})`,
      "--toastify-font-family": fonts.body
    }),
    children: /* @__PURE__ */ jsx5(ReactToastifyToastContainer, {
      ...props
    })
  });
};
export {
  Accordion,
  InstallPwa,
  Modal,
  ToastContainer,
  toast
};
